import { InputField } from '@gasbi/shared/common/components/FormFields';
import { FormSection } from '@gasbi/shared/web/components/FormSection';
import { Row } from '@gasbi/shared/web/forms/styled';

import { AddressForm } from '@/forms/AddressForm';

import { CreateOrganizationStepProps } from '../types';

// The ЄДРА registry address, as Supply's card picks it, and the office as a field of its own (GSB-8433); a ГРМ and its
// підрозділи share this step.
const AddressStep = ({ formik }: CreateOrganizationStepProps) => (
  <FormSection title='Адреса'>
    <AddressForm formik={formik} unwrap />
    <Row>
      <InputField
        control={formik}
        name='officeNumber'
        label='№ офісу'
        placeholder='Введіть значення'
        maxLength={20}
      />
    </Row>
  </FormSection>
);

export default AddressStep;
